/**
 * Standard button props for action buttons in drawer sections.
 */
export const BUTTON_PROPS = {
  sx: { px: 1, ml: -1 },
  size: 'small' as const,
  variant: 'text' as const,
}

/**
 * Container styles for hoverable drawer sections with show-on-hover pattern.
 */
export const CONTAINER_SX = {
  px: 3,
  py: 1,
  '&:hover': { backgroundColor: 'action.hover' },
  '& .show-on-hover': { opacity: 0 },
  '&:hover .show-on-hover': { opacity: 1 },
}
